import externalEventCodes from 'event-system/codes/external';
import internalEventCodes from 'event-system/codes/internal';

class NotificationsManager {

  constructor(application) {

    this.application = application;
    this.actualTitle = document.title;
    this.notificationTitle = null;
    this.titleSwapInterval = null;
    this.titleNotificationActive = false;

    this.application.eventSystem.internal.eventFor(this, externalEventCodes.INBOUND_CONVERSATION_MESSAGE_CREATED, this.tryNotifyIncomingMessage.bind(this));

    document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this));

    navigator.serviceWorker.addEventListener('message', function(event) {
      const data = event.data;

      if (data.type !== 'INCOMING_MESSAGE_NOTIFICATION') {
        return;
      }

      this.notifyIncomingMessage(data.data);
    }.bind(this));

    navigator.serviceWorker.addEventListener('message', function(event) {
      const data = event.data;

      if (data.type !== 'RESET_TITLE_BAR_NOTIFICATION') {
        return;
      }

      this.clearTitleBarNotification();
    }.bind(this));

  }

  handleVisibilityChange() {

    if (document.visibilityState !== 'visible') {
      return;
    }

    if (navigator.serviceWorker.controller === null) {
      return;
    }

    navigator.serviceWorker.controller.postMessage({
      type: 'RESET_TITLE_BAR_NOTIFICATION'
    });

  }

  clearTitleBarNotification() {

    clearInterval(this.titleSwapInterval);
    document.title = this.actualTitle;

  }

  notifyViaBrowser(message) {

    if (document.title !== this.notificationTitle) {
      this.actualTitle = document.title;
    }

    this.notificationTitle = message;

    clearInterval(this.titleSwapInterval);
    this.titleSwapInterval = setInterval(() => {
      document.title = document.title === this.actualTitle ? this.notificationTitle : this.actualTitle;
    }, 1000);

  }

  notifyViaOS(message, icon = void 0, messageId) {

    const options = {
      icon,
      tag: messageId
    };

    if (!('Notification' in window)) {

    } else if (Notification.permission === 'granted') {
      new Notification(message, options);
    } else if (Notification.permission !== 'denied') {
      // We need to ask the user for permission
      Notification.requestPermission().then((permission) => {
        // If the user accepts, let's create a notification
        if (permission === 'granted') {
          new Notification(message, options);
        }
      });
    }
  }

  notifyIncomingMessage(payload) {

    this.notifyViaOS(payload.message.serializedContent.text, payload.message.sender.profilePicture.url, payload.message._id);
    this.application.audioManager.incomingMessageSound.play();

  }

  tryNotifyIncomingMessage(payload) {

    if (payload.message.labelSet.includes('SPAM') || payload.message.labelSet.includes('QUARANTINE')) {
      return;
    }

    this.application.eventSystem.internal.emit(internalEventCodes.SHOW_NAVIGATION_CUE, { menuItemName: 'Inbox' });

    if (payload.message.sender.fromName === 'Assistant') {
      this.application.eventSystem.internal.emit('SHOW_NEW_ASSISTANT_MESSAGE_CUE', {});
    }

    // this.notifyViaBrowser(`${payload.message.sender.fromName} says: ${payload.message.serializedContent.text}`);

    if (navigator.serviceWorker.controller === null) {
      this.notifyIncomingMessage(payload);
      return;
    }
    navigator.serviceWorker.controller.postMessage({
      type: 'INCOMING_MESSAGE_NOTIFICATION',
      data: payload
    });

  }

}

export default NotificationsManager;
